document.addEventListener("DOMContentLoaded", function () {
  if (typeof tippy !== "undefined") {
    // Initialize tooltips for feature list items (uses template for HTML content)
    const tooltipElements = document.querySelectorAll(".feature-with-tooltip");

    tooltipElements.forEach(function (element) {
      const template = element.previousElementSibling;
      if (template && template.classList.contains("tooltip-template")) {
        const isInteractive = element.classList.contains(
          "feature-with-tooltip--interactive"
        );
        const options = {
          allowHTML: true,
          placement: "top",
          theme: "dark",
          arrow: true,
          interactive: isInteractive,
          maxWidth: 300,
          content: template.innerHTML,
        };
        if (isInteractive) {
          options.hideOnClick = false;
          options.appendTo = document.body;
        }
        tippy(element, options);
      }
    });

    // Initialize tooltips for footnote tooltips (uses data-tippy-content for simple text)
    tippy(".footnote-tooltip", {
      placement: "top",
      theme: "dark",
      arrow: true,
      interactive: false,
    });
  }

  // Add shadow to sticky comparison header only when it's actually sticky
  function updateScrolledComparisonHeader() {
    const comparisonHeader = document.querySelector(
      ".comparison__shared-header"
    );
    if (!comparisonHeader) {
      return;
    }

    // Check if the header is actually in sticky position
    // The header becomes sticky at top: 75px, so check if its top position equals 75px
    const rect = comparisonHeader.getBoundingClientRect();
    const stickyTop = 75; // matches top: 75px in CSS

    // Header is sticky when its top position equals the sticky top value
    // Add a small tolerance (1px) for rounding
    if (Math.abs(rect.top - stickyTop) < 1) {
      comparisonHeader.classList.add("is-scrolled");
    } else {
      comparisonHeader.classList.remove("is-scrolled");
    }
  }

  // Update sticky header section title based on which table is visible
  function updateStickySectionTitle() {
    const stickyTitle = document.querySelector(
      ".comparison__sticky-section-title"
    );
    if (!stickyTitle) {
      return;
    }

    const sections = document.querySelectorAll(".comparison__table-section");
    const stickyHeader = document.querySelector(".comparison__shared-header");
    if (!stickyHeader) {
      return;
    }

    const stickyHeaderRect = stickyHeader.getBoundingClientRect();
    const stickyTop = 75; // matches top: 75px in CSS
    const isSticky = Math.abs(stickyHeaderRect.top - stickyTop) < 1;

    // Only update title when header is sticky
    if (!isSticky) {
      stickyTitle.textContent = "";
      return;
    }

    // Find which section title is currently closest to or above the sticky header
    let currentSection = null;
    let closestDistance = Infinity;

    sections.forEach((section) => {
      const sectionTitle = section.querySelector(
        ".comparison__table-section-title"
      );
      if (!sectionTitle) {
        return;
      }

      const titleRect = sectionTitle.getBoundingClientRect();
      const sectionRect = section.getBoundingClientRect();

      // Check if the section title is above or at the sticky header position
      // We want to show the title of the section that's currently being viewed
      if (titleRect.bottom <= stickyTop + 150) {
        // Section title is above or near the sticky header
        const distance = Math.abs(titleRect.bottom - stickyTop);
        if (distance < closestDistance) {
          closestDistance = distance;
          currentSection = sectionTitle;
        }
      } else if (
        sectionRect.top <= stickyTop + 50 &&
        sectionRect.bottom > stickyTop
      ) {
        // Section is currently visible at the sticky header position
        const distance = Math.abs(sectionRect.top - stickyTop);
        if (distance < closestDistance) {
          closestDistance = distance;
          currentSection = sectionTitle;
        }
      }
    });

    // Update the sticky header title
    if (currentSection) {
      const newTitle = currentSection.textContent.trim();
      if (stickyTitle.textContent !== newTitle) {
        stickyTitle.textContent = newTitle;
      }
    }
  }

  // Throttle scroll events for better performance
  let scrollTimeout;

  function handleScroll() {
    if (scrollTimeout) {
      cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = requestAnimationFrame(() => {
      updateScrolledComparisonHeader();
      updateStickySectionTitle();
    });
  }

  // Set up scroll listener and initialize on page load
  window.addEventListener("scroll", handleScroll, { passive: true });
  updateScrolledComparisonHeader();
  updateStickySectionTitle();
});
